export default __webpack_public_path__ + "static/media/francheville01.13ea12da.jpg";